export default {


    computed: {
        //业务类型
        getBusinessType() {
            return [{
                label: this.$t('fbb.adjustment.list_transfer', { defaultValue: "中转费用" }),
                value: 1
            }, {
                label: this.$t('fbb.adjustment.list_common', { defaultValue: "一般入库" }),
                value: 2
            }, {
                label: this.$t('fbb.adjustment.list_sale', { defaultValue: "销售订单" }),
                value: 3
            }, {
                label: this.$t('fbb.adjustment.list_storage', { defaultValue: "仓储" }),
                value: 4
            }, {
                label: this.$t('fbb.costmanage.other', { defaultValue: "其他" }),
                value: 5
            }, {
                label: this.$t('fbb.adjustment.list_sub', { defaultValue: "调拨" }),
                value: 6
            }, {
                label: this.$t('fbb.adjustment.list_return', { defaultValue: "退货" }),
                value: 7
            }, {
                label: "All",
                value: 10
            },{
                label: this.$t('fbb.adjustment.list_nosource', { defaultValue: "无来源入库" }),
                value: 11
            }]
        },
        //事务项
        getTransaction() {
            return [{
                label: this.$t('fbb.costmanage.created', { defaultValue: "已创建" }),
                value: this.$t('fbb.costmanage.created', { defaultValue: "已创建" }),
            }, {
                label: this.$t('global.common.confirmed', { defaultValue: "已确认" }),
                value: this.$t('global.common.confirmed', { defaultValue: "已确认" }),
            }, {
                label: this.$t('fbb.costmanage.caculated', { defaultValue: "已结算" }),
                value: this.$t('fbb.costmanage.caculated', { defaultValue: "已结算" }),
            },]
        },
        //事务项
        getPayStatus() {
            return [{
                label: this.$t('fbb.costmanage.created', { defaultValue: "已创建" }),
                value: this.$t('fbb.costmanage.created', { defaultValue: "已创建" }),
            }, {
                label: this.$t('global.common.confirmed', { defaultValue: "已确认" }),
                value: this.$t('global.common.confirmed', { defaultValue: "已确认" }),
            }, {
                label: this.$t('fbb.costmanage.caculated', { defaultValue: "已结算" }),
                value: this.$t('fbb.costmanage.caculated', { defaultValue: "已结算" }),
            },]
        },
    },
}
